import { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import DataGrid from '../../dataGrid/DataGrid';
import ExcelExport from '../../excelExport/ExcelExport';
import RefreshIcon from './reload.svg';
import TrashIcon from './trash.svg';
import PlusIcon from './plus.svg';
import { Spinner } from 'react-bootstrap';
import GridProfile from '../gridProfile/GridProfile';

const DataGridWithHeaderAndFooter = forwardRef(function DataGridWithHeaderAndFooter(props, ref) {
  const GridProfileRef = useRef();

  const [gridApi, setGridApi] = useState();

  function onDelete() {
    const selectedRows = gridApi.getSelectedRows();
    props.onDelete(selectedRows);
  }

  if (props.dataLoadingState === 'LOADING') {
    return (
      <div className='spinner-centered'>
        <Spinner animation='border' variant='success' />
      </div>
    )
  }

  function onGridReady(params) {
    setGridApi(params.api)
    if (props.onGridReady) {
      props.onGridReady(params);
    }
  }

  let gridVisible = (props.dataLoadingState === 'LOADED')
  let gridColumns = (gridVisible) ? GridProfileRef?.current?.getGridColumns() || [] : [];

  return (
    <div className="datagrid-body">
      {
        (gridVisible) &&
        <>
          <div className="datagrid-body-header">
            <div className='buttons-on-top'>
              {props.buttonsOnTop}
            </div>
            <div className='buttons-main-controls'>
              <div className='buttons-on-left'>
                {props.onAddNew &&
                  <button type="button" className="btn btn-warning btn-add" onClick={() => props.onAddNew()}>
                    <img className="Add-icon" src={PlusIcon} alt="Add-icon.svg" />
                  </button>
                }
                {props.buttonsOnLeft}
              </div>
              {props.onDelete &&
                <button type="button" className="btn btn-warning btn-delete" onClick={onDelete}>
                  <img className="Delete-icon" src={TrashIcon} alt="Trash-icon.svg" />
                </button>
              }
              {!props.report?.data &&
                <button button type="button" className="btn btn-warning btn-refresh-report" onClick={props.onRefresh}>
                  <img className="Refresh-icon" src={RefreshIcon} alt="Refresh-icon.svg" />
                </button>
              }
              <div className='buttons-on-right'>
                {props.buttonsOnRight}
                <ExcelExport data={props.gridData} />
              </div>
            </div>
          </div>

          <DataGrid
            id={`${props.id}-dataGrid`}
            loginSettingsKey={props.id}
            columns={gridColumns}
            languageElements={props.report.languageElements}
            data={props.gridData}
            cellFunctions={props.cellFunctions}
            rowSelection={props.rowSelection}
            isRowSelectable={props.isRowSelectable}
            rowMultiSelectWithClick={props.rowMultiSelectWithClick}
            onSelectionChanged={props.onSelectionChanged}
            rowDesign={props.report.rowDesign}
            checkboxColumn={props.checkboxColumn}
            onRowDoubleClick={props.onRowDoubleClick}
            gridHeight={props.gridHeight}
            onGridReady={onGridReady}
          />
        </>
      }

      <GridProfile
        ref={GridProfileRef}
        visible={gridVisible}
        loginSettingsKey={props.id}
        setDataLoadingState={props.setDataLoadingState}
        report={props.report}
        gridApi={gridApi}
      />

    </div>
  )
});

export default DataGridWithHeaderAndFooter;
